// ============================================================
// Expense Service Layer
// ============================================================

import { expensesApi } from '@/api/expenses.api';

export const expenseService = {
  // Categories
  getCategories: async (schoolId, includeInactive = false) => {
    return await expensesApi.getCategories(schoolId, includeInactive);
  },

  createCategory: async (schoolId, payload) => {
    return await expensesApi.createCategory(schoolId, payload);
  },

  updateCategory: async (schoolId, id, payload) => {
    return await expensesApi.updateCategory(schoolId, id, payload);
  },

  deleteCategory: async (schoolId, id) => {
    return await expensesApi.deleteCategory(schoolId, id);
  },

  // Expenses
  getExpenses: async (schoolId, params = {}) => {
    return await expensesApi.getExpenses(schoolId, params);
  },

  getExpenseById: async (schoolId, id) => {
    return await expensesApi.getExpenseById(schoolId, id);
  },

  createExpense: async (schoolId, payload) => {
    return await expensesApi.createExpense(schoolId, payload);
  },

  updateExpense: async (schoolId, id, payload) => {
    return await expensesApi.updateExpense(schoolId, id, payload);
  },

  deleteExpense: async (schoolId, id) => {
    return await expensesApi.deleteExpense(schoolId, id);
  },

  getSummaryTotal: async (schoolId, params = {}) => {
    return await expensesApi.getSummaryTotal(schoolId, params);
  },

  getDashboardOverview: async (schoolId, params = {}) => {
    return await expensesApi.getDashboardOverview(schoolId, params);
  },
};
